// AUTO-GENERATED by scripts/generate-build-info.js at build time — do not edit by hand.
// See generate-build-info.js for why this file stays checked in with placeholder values.
export const BUILD_VERSION = "0.1.0";
export const BUILD_SHA = "02d7953";
export const BUILD_STAMP = "0.1.0+02d7953";
